import { IProfessionalCardRating } from './interfaces';

/**
 * The API's "average rating" object shape (e.g. `averageProfessionalRating` /
 * `overallProfessionalRating`). Maps to the card's `IProfessionalCardRating`.
 */
export interface IAverageRating {
  averageRating?: number;
  averageInterpersonalSkills?: number;
  averageProfessionalSkills?: number;
  averageTimeManagement?: number;
}

/**
 * Builds a card `rating` from an API averages object, returning `undefined` when there is none.
 * Centralizes the target shape the three lists were each constructing inline.
 */
export const buildCardRating = (
  averages?: IAverageRating | null,
): IProfessionalCardRating | undefined =>
  averages == null
    ? undefined
    : {
        averageRating: averages.averageRating,
        interpersonalSkills: averages.averageInterpersonalSkills,
        professionalSkills: averages.averageProfessionalSkills,
        timeManagement: averages.averageTimeManagement,
      };
